import React, { ReactNode } from 'react'
import Caption from '../Caption/Caption'
import FreeText from '../FreeText/FreeText'
import Label from '../Label/Label'
import styles from './Fieldset.module.scss'

export type FieldsetProps = {
  label: ReactNode
  children: ReactNode
}
export default function Fieldset(props: FieldsetProps) {
  const { label, children } = props
  return (
    <div className={styles.fieldset}>
      <Caption type="md" as="label">
        {label}
      </Caption>
      <FreeText type="md" color="primary" as="span">
        {children}
      </FreeText>
    </div>
  )
}
